import styled from 'styled-components';

export const UpdateImg = styled.img`
  border-radius: 8px;
  overflow: hidden;
`;

export const UploadWrapper = styled.div`
  &.hide-border
    .ant-upload-wrapper.ant-upload-picture-card-wrapper
    .ant-upload.ant-upload-select {
    border-color: transparent;
    background: transparent;
  }
`;
